import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isEditResourceWeeklyCalendarRequestFailure({ uuid }) {
      const req = getState().find(({ resource }) => resource.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isEditResourceWeeklyCalendarRequestPending({ uuid }) {
      const req = getState().find(({ resource }) => resource.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isEditResourceWeeklyCalendarRequestSuccess({ uuid }) {
      const req = getState().find(({ resource }) => resource.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
